import { whyReasons } from '@/mocks/seoContent';

export default function WhySection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-medium text-accent-600 uppercase tracking-widest mb-3">The Advantage</p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Why Everyone Is Switching to{' '}
            <em className="italic text-accent-600">ItaobuySpreadsheet</em>
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Thousands of international buyers have already moved away from traditional agents. Here is why the <strong>itaobuyspreadsheet</strong> method is winning.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {whyReasons.map((reason) => (
            <div key={reason.title} className="p-6 rounded-2xl bg-background-50 border border-background-200/60 hover:border-accent-200/60 transition-colors">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 mb-4">
                <i className={`${reason.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">{reason.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{reason.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}